export default {
  API_ENDPOINT: 'https://protected-wildwood-57753.herokuapp.com/api',
  TOKEN_KEY: 'blogful-client-auth-token',
  // API_ENDPOINT: 'http://localhost:8000/api'
}
